import deepFreeze from 'deep-freeze-strict';
import { collectionConstructorFactory } from "../collection/collectionConstructorFactory";
import { anyRequestApiTemplate } from "./apis/anyRequest";
export const anyTemplate = deepFreeze({
  templateId: 'any',
  name: '单接口',
  desc: '只包含单个接口的数据源，无参数类型限制',
  apiTemplates: [anyRequestApiTemplate]
});
export const AnyCollection = collectionConstructorFactory(anyTemplate);
//# sourceMappingURL=Any.js.map
